import React from 'react';
import ReactMarkdown from 'react-markdown';

import { FooterContentEntity } from '../../domain/entities/FooterContentEntity';
import { COPYRIGHT_INFO } from '../../domain/store/FooterStore';
import styles from '../styles/Footer.module.scss';

interface FooterLegalInfoCmpProps {
  footer_data?: FooterContentEntity;
}

function FooterLegalInfoCmp({
  footer_data,
}: Readonly<FooterLegalInfoCmpProps>): React.ReactElement {
  return (
    <div className={styles['footer-legal-info']}>
      <div className={styles['copyright-wrapper']}>
        <div className={styles['info']}>
          {footer_data ? (
            <ReactMarkdown>{footer_data.company_info}</ReactMarkdown>
          ) : (
            COPYRIGHT_INFO
          )}
        </div>
      </div>
    </div>
  );
}

export default FooterLegalInfoCmp;
